<div class="wrapper">
  <div class="page">
    Body
  </div>
  <div class="bottom-appbar">
    <div class="tabs">
      <div class="tab is-active tab--left" (click)="goTo('menu')">        
        <span>Mon profile</span>
      </div>
      <div class="tab tab--fab">
        <div class="top">
          <button class="fab">
          </button>
        </div>
      </div>
      <div class="tab tab--right">
        <span>Mes demandes</span>
      </div>
    </div>
  </div>
</div>